module.exports = __webpack_public_path__ + "static/media/logo_trice.9930dcbf.png";